import {
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS,
  DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET,
  GET_ESIM_CARD_PROFILE_TYPE,
  GET_ESIM_CARD_PROFILE_TYPE_FAILURE,
  GET_ESIM_CARD_PROFILE_TYPE_SUCCESS,
  PDPA_DELETE_EXIST_RESADDR_FAILURE,
  PDPA_DELETE_EXIST_RESADDR_REQUEST,
  PDPA_DELETE_EXIST_RESADDR_SUCCESS,
  PDPA_RETREIVE_RESADDRESS_FAILURE,
  PDPA_RETREIVE_RESADDRESS_REQUEST,
  PDPA_RETREIVE_RESADDRESS_SUCCESS,
  PDPA_SAVE_NEW_RESADDR_FAILURE,
  PDPA_SAVE_NEW_RESADDR_REQUEST,
  PDPA_SAVE_NEW_RESADDR_SUCCESS,
  PDPA_UPDATE_EXIST_RESADDR_FAILURE,
  PDPA_UPDATE_EXIST_RESADDR_REQUEST,
  PDPA_UPDATE_EXIST_RESADDR_SUCCESS,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
  UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS
} from './actionTypes';
import { IError, Idata } from '@/components/Checkout/PDPABuyFlow/ResidentialAddress/models/resAdd';
import { DownloadMultilineReceipientsESimFailure, DownloadMultilineReceipientsESimRequest, DownloadMultilineReceipientsESimSuccess, UploadMultiLineESimFileFailure, UploadMultiLineESimFileSuccess} from './model/type';

export const GET_DELIVERY_SLOTS = 'GET_DELIVERY_SLOTS';
export const GET_DELIVERY_SLOTS_SUCCESS = 'GET_DELIVERY_SLOTS_SUCCESS';
export const GET_DELIVERY_SLOTS_FAILURE = 'GET_DELIVERY_SLOTS_FAILURE';

export const getDeliverySlots = {
  request: () => ({ type: GET_DELIVERY_SLOTS }),
  success: (data) => ({ type: GET_DELIVERY_SLOTS_SUCCESS, data }),
  failure: (error) => ({ type: GET_DELIVERY_SLOTS_FAILURE, error })
};

export const GET_ADDRESS_BY_POSTALCODE = 'GET_ADDRESS_BY_POSTALCODE';
export const GET_ADDRESS_BY_POSTALCODE_SUCCESS = 'GET_ADDRESS_BY_POSTALCODE_SUCCESS';
export const GET_ADDRESS_BY_POSTALCODE_FAILURE = 'GET_ADDRESS_BY_POSTALCODE_FAILURE';

export const getAddressByPostalCode = {
  request: (postalCode: string, callback: ((error: IError, data?: Idata) => void) | null = () => {}) => ({
    type: GET_ADDRESS_BY_POSTALCODE,
    postalCode,
    callback
  })
};

export const GET_DELIVERY_ADDRESS_LIST = 'GET_DELIVERY_ADDRESS_LIST';
export const GET_DELIVERY_ADDRESS_LIST_SUCCESS = 'GET_DELIVERY_ADDRESS_LIST_SUCCESS';
export const GET_DELIVERY_ADDRESS_LIST_FAILURE = 'GET_DELIVERY_ADDRESS_LIST_FAILURE';

export const getDeliveryAddressList = {
  request: () => ({ type: GET_DELIVERY_ADDRESS_LIST }),
  success: (data) => ({ type: GET_DELIVERY_ADDRESS_LIST_SUCCESS, data }),
  failure: (error) => ({ type: GET_DELIVERY_ADDRESS_LIST_FAILURE, error })
};

export const UPDATE_DELIVERY_ADDRESS = 'UPDATE_DELIVERY_ADDRESS';
export const UPDATE_DELIVERY_ADDRESS_SUCCESS = 'UPDATE_DELIVERY_ADDRESS_SUCCESS';
export const UPDATE_DELIVERY_ADDRESS_FAILURE = 'UPDATE_DELIVERY_ADDRESS_FAILURE';

export const updateDeliveryAddress = {
  request: (address) => ({ type: UPDATE_DELIVERY_ADDRESS, address }),
  success: (data) => ({ type: UPDATE_DELIVERY_ADDRESS_SUCCESS, data }),
  failure: (error) => ({ type: UPDATE_DELIVERY_ADDRESS_FAILURE, error })
};

export const DELETE_DELIVERY_ADDRESS = 'DELETE_DELIVERY_ADDRESS';
export const DELETE_DELIVERY_ADDRESS_SUCCESS = 'UPDATE_DELIVERY_ADDRESS_SUCCESS';
export const DELETE_DELIVERY_ADDRESS_FAILURE = 'UPDATE_DELIVERY_ADDRESS_FAILURE';

export const deleteDeliveryAddress = {
  request: (address) => ({ type: DELETE_DELIVERY_ADDRESS, address }),
  success: (data) => ({ type: DELETE_DELIVERY_ADDRESS_SUCCESS, data }),
  failure: (error) => ({ type: DELETE_DELIVERY_ADDRESS_FAILURE, error })
};
export const GET_CUSTOMER_IDS = 'GET_CUSTOMER_IDS';
export const GET_CUSTOMER_IDS_SUCCESS = 'GET_CUSTOMER_IDS_SUCCESS';
export const GET_CUSTOMER_IDS_FAILURE = 'GET_CUSTOMER_IDS_FAILURE';

export const getCustomerIds = {
  request: () => ({ type: GET_CUSTOMER_IDS }),
  success: (data) => ({ type: GET_CUSTOMER_IDS_SUCCESS, data }),
  failure: (error) => ({ type: GET_CUSTOMER_IDS_FAILURE, error })
};

export const GET_PAYMENT_TYPES = 'GET_PAYMENT_TYPES';
export const GET_PAYMENT_TYPES_SUCCESS = 'GET_PAYMENT_TYPES_SUCCESS';
export const GET_PAYMENT_TYPES_FAILURE = 'GET_PAYMENT_TYPES_FAILURE';

export const getPaymentTypes = {
  request: () => ({ type: GET_PAYMENT_TYPES }),
  success: (data) => ({ type: GET_PAYMENT_TYPES_SUCCESS, data }),
  failure: (error) => ({ type: GET_PAYMENT_TYPES_FAILURE, error })
};

export const GET_BILLING_ADDRESS_LIST = 'GET_BILLING_ADDRESS_LIST';
export const GET_BILLING_ADDRESS_LIST_SUCCESS = 'GET_BILLING_ADDRESS_LIST_SUCCESS';
export const GET_BILLING_ADDRESS_LIST_FAILURE = 'GET_BILLING_ADDRESS_LIST_FAILURE';

export const getBillingAddressList = {
  request: (reqData) => ({
    type: GET_BILLING_ADDRESS_LIST,
    reqData
  }),
  success: (data) => ({ type: GET_BILLING_ADDRESS_LIST_SUCCESS, data }),
  failure: (error) => ({ type: GET_BILLING_ADDRESS_LIST_FAILURE, error })
};

export const GET_POPSTATION_LIST = 'GET_POPSTATION_LIST';
export const GET_POPSTATION_LIST_SUCCESS = 'GET_POPSTATION_LIST_SUCCESS';
export const GET_POPSTATION_LIST_FAILURE = 'GET_POPSTATION_LIST_FAILURE';

export const getPOPStationList = {
  request: () => ({ type: GET_POPSTATION_LIST }),
  success: (data) => ({ type: GET_POPSTATION_LIST_SUCCESS, data }),
  failure: (error) => ({ type: GET_POPSTATION_LIST_FAILURE, error })
};

export const GET_POPSTATION_ADDRESS_BY_POSTALCODE = 'GET_POPSTATION_ADDRESS_BY_POSTALCODE';
export const GET_POPSTATION_ADDRESS_BY_POSTALCODE_SUCCESS = 'GET_POPSTATION_ADDRESS_BY_POSTALCODE_SUCCESS';
export const GET_POPSTATION_ADDRESS_BY_POSTALCODE_FAILURE = 'GET_POPSTATION_ADDRESS_BY_POSTALCODE_FAILURE';

export const getPOPStationAddressByPostalCode = {
  request: (postalCode, callback) => ({
    type: GET_POPSTATION_ADDRESS_BY_POSTALCODE,
    postalCode,
    callback
  })
};

export const GET_ALL_DELIVERY_CHARGES_REQUEST = 'GET_ALL_DELIVERY_CHARGES_REQUEST';
export const GET_ALL_DELIVERY_CHARGES_SUCCESS = 'GET_ALL_DELIVERY_CHARGES_SUCCESS';
export const GET_ALL_DELIVERY_CHARGES_FAILURE = 'GET_ALL_DELIVERY_CHARGES_FAILURE';

export const getAllDeliveryCharges = {
  request: () => ({ type: GET_ALL_DELIVERY_CHARGES_REQUEST }),
  success: (data) => ({ type: GET_ALL_DELIVERY_CHARGES_SUCCESS, data }),
  failure: (error) => ({ type: GET_ALL_DELIVERY_CHARGES_FAILURE, error })
};

export const GET_SPLIT_PAYMENT_TYPE_REQUEST = 'GET_SPLIT_PAYMENT_TYPE_REQUEST';
export const GET_SPLIT_PAYMENT_TYPE_SUCCESS = 'GET_SPLIT_PAYMENT_TYPE_SUCCESS';
export const GET_SPLIT_PAYMENT_TYPE_FAILURE = 'GET_SPLIT_PAYMENT_TYPE_FAILURE';

export const getAllowSplitPaymentType = {
  request: (brn) => ({ type: GET_SPLIT_PAYMENT_TYPE_REQUEST, brn }),
  success: (data) => ({ type: GET_SPLIT_PAYMENT_TYPE_SUCCESS, data }),
  failure: (error) => ({ type: GET_SPLIT_PAYMENT_TYPE_FAILURE, error })
};

export const pdpaRetreiveResidentialAddress = {
  request: () => ({ type: PDPA_RETREIVE_RESADDRESS_REQUEST }),
  success: (data) => ({ type: PDPA_RETREIVE_RESADDRESS_SUCCESS, data }),
  failure: (error) => ({ type: PDPA_RETREIVE_RESADDRESS_FAILURE, error })
};

export const pdpaSaveNewResAddress = {
  request: (address) => ({ type: PDPA_SAVE_NEW_RESADDR_REQUEST, address }),
  success: (data) => ({ type: PDPA_SAVE_NEW_RESADDR_SUCCESS, data }),
  failure: (error) => ({ type: PDPA_SAVE_NEW_RESADDR_FAILURE, error })
};

export const pdpaUpdateExistResAddress = {
  request: (address) => ({ type: PDPA_UPDATE_EXIST_RESADDR_REQUEST, address }),
  success: (data) => ({ type: PDPA_UPDATE_EXIST_RESADDR_SUCCESS, data }),
  failure: (error) => ({ type: PDPA_UPDATE_EXIST_RESADDR_FAILURE, error })
};

export const pdpaDeleteExistResAddress = {
  request: (address) => ({ type: PDPA_DELETE_EXIST_RESADDR_REQUEST, address }),
  success: (data) => ({ type: PDPA_DELETE_EXIST_RESADDR_SUCCESS, data }),
  failure: (error) => ({ type: PDPA_DELETE_EXIST_RESADDR_FAILURE, error })
};

export const CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST = 'CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST';
export const CHECK_CUSTOMER_CODE_ELIGIBILITY_SUCCESS = 'CHECK_CUSTOMER_CODE_ELIGIBILITY_SUCCESS';
export const CHECK_CUSTOMER_CODE_ELIGIBILITY_FAILURE = 'CHECK_CUSTOMER_CODE_ELIGIBILITY_FAILURE';

export const checkCustCodeEligibility = {
  request: (payload) => ({ type: CHECK_CUSTOMER_CODE_ELIGIBILITY_REQUEST, payload }),
  success: (data) => ({ type: CHECK_CUSTOMER_CODE_ELIGIBILITY_SUCCESS, data }),
  failure: (error) => ({ type: CHECK_CUSTOMER_CODE_ELIGIBILITY_FAILURE, error })
};

export const GET_BILLING_ADDRESS_LIST_SERVICE_NO = 'GET_BILLING_ADDRESS_LIST_SERVICE_NO';
export const GET_BILLING_ADDRESS_LIST_SERVICE_NO_SUCCESS = 'GET_BILLING_ADDRESS_LIST_SERVICE_NO_SUCCESS';
export const GET_BILLING_ADDRESS_LIST_SERVICE_NO_FAILURE = 'GET_BILLING_ADDRESS_LIST_SERVICE_NO_FAILURE';

export const getBillingAddressListServiceNo = {
  request: () => ({ type: GET_BILLING_ADDRESS_LIST_SERVICE_NO }),
  success: (data) => ({ type: GET_BILLING_ADDRESS_LIST_SERVICE_NO_SUCCESS, data }),
  failure: (error) => ({ type: GET_BILLING_ADDRESS_LIST_SERVICE_NO_FAILURE, error })
};

export const GET_PORT_IN_DATE_LIST = 'GET_PORT_IN_DATE_LIST';
export const GET_PORT_IN_DATE_LIST_SUCCESS = 'GET_PORT_IN_DATE_LIST_SUCCESS';
export const GET_PORT_IN_DATE_LIST_FAILURE = 'GET_PORT_IN_DATE_LIST_FAILURE';

export const getPortInDatesList = {
  request: (payload) => ({ type: GET_PORT_IN_DATE_LIST, payload }),
  success: (data) => ({ type: GET_PORT_IN_DATE_LIST_SUCCESS, data }),
  failure: (error) => ({ type: GET_PORT_IN_DATE_LIST_FAILURE, error })
};

export const getESimCardProfileType = {
  request: (payload) => ({ type: GET_ESIM_CARD_PROFILE_TYPE, payload }),
  success: (data) => ({ type: GET_ESIM_CARD_PROFILE_TYPE_SUCCESS, data }),
  failure: (error) => ({ type: GET_ESIM_CARD_PROFILE_TYPE_FAILURE, error })
};

export const uploadMultilineReceipientsESim = {
  // request: (fileData, cartId) :UploadMultiLineESimFileRequest=> ({
    request: (fileData, cartId) => ({
    type: UPLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
    fileData,
    cartId
    
  }),
  success: (data):UploadMultiLineESimFileSuccess => ({ type: UPLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS,data }),
  failure: (error):UploadMultiLineESimFileFailure => ({ type: UPLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE, error })
};


export const downloadMultilineReceipientsESim = {
  request: ( cartId) :DownloadMultilineReceipientsESimRequest=> ({
    type: DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_REQUEST,
    cartId
    
  }),
  success: (data):DownloadMultilineReceipientsESimSuccess => ({ type: DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_SUCCESS,data }),
  failure: (error):DownloadMultilineReceipientsESimFailure => ({ type: DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_FAILURE, error })
};
export const downloadMutlilineRecipientReset = {
  request: () => ({
    type: DOWNLOAD_MULTILINE_RECEIPIENTS_ESIM_RESET
  })
}